/* OVERAALL V8.7 — intro shown only once per browser tab session, after click.
 * The Shopify theme editor keeps the intro visible for editing. */
(()=>{'use strict';
  const inEditor=document.documentElement.hasAttribute('data-ov87-shopify-editor');
  const intro=document.getElementById('ov62-entry');
  if(!intro||inEditor)return;
  const key='overaall-entry-visited-v87';
  let previouslyEntered=false;
  try{previouslyEntered=sessionStorage.getItem(key)==='1';}catch(e){}
  if(previouslyEntered){intro.remove();document.documentElement.classList.add('ov87-entry-seen');return;}
  const enter=intro.querySelector('.ov62-entry-button');
  enter?.addEventListener('click',()=>{
    try{sessionStorage.setItem(key,'1');}catch(e){}
  },{capture:true,once:true});
})();

